module.exports = __webpack_public_path__ + "static/media/LingHacks2018.81c4f105.jpg";